import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/services/settings.service';
import { NotificationService } from '../../../core/services/notification.service';
import { ClinicSubscriptionDto } from '../../../core/models/subscription-settings.model';
import { SubscriptionPaymentStatus } from '../../../core/models/subscription-payment.model';
import { ClinicInvoice } from '../../../core/models/clinic-invoice.model';

@Component({
  selector: 'app-subscription-settings',
  imports: [CommonModule],
  templateUrl: './subscription-settings.html',
  styleUrl: './subscription-settings.scss',
})
export class SubscriptionSettings implements OnInit {
  isLoading = false;
  isInvoicesLoading = false;

  currentSubscription: ClinicSubscriptionDto | null = null;
  paymentStatus: SubscriptionPaymentStatus | null = null;
  isStartingPayment = false;

  invoices: ClinicInvoice[] = [];

  constructor(
    private settingsService: SettingsService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.loadSubscriptionData();
    this.loadPaymentStatus();
  }

  private loadSubscriptionData(): void {
    this.isLoading = true;

    this.settingsService.getClinicSubscription().subscribe({
      next: (subscription) => {
        console.log('Subscription loaded:', subscription);
        this.currentSubscription = subscription;
        if (subscription?.clinicId) {
          console.log('Clinic ID found, loading invoices for:', subscription.clinicId);
          this.loadInvoices(subscription.clinicId);
        } else {
          console.warn('No clinicId in subscription');
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Failed to load subscription:', error);
        this.notificationService.error(
          'Failed to load practice subscription: ' +
            (error?.error?.message || error.message || 'Unknown error'),
        );
        this.isLoading = false;
      },
    });
  }

  private loadInvoices(clinicId: string): void {
    this.isInvoicesLoading = true;
    console.log('Starting invoice load for clinic:', clinicId);
    this.settingsService.getClinicInvoices(clinicId).subscribe({
      next: (invoices) => {
        console.log('Invoices loaded successfully:', invoices);
        this.invoices = invoices;
        this.isInvoicesLoading = false;
      },
      error: (error) => {
        console.error('Failed to load invoices:', error);
        this.notificationService.error(
          'Failed to load invoices: ' + (error?.error?.message || error.message || 'Unknown error'),
        );
        this.invoices = [];
        this.isInvoicesLoading = false;
      },
    });
  }

  invoiceStatusClass(status: ClinicInvoice['status']): string {
    switch (status) {
      case 'PAID':
        return 'bg-success-subtle text-success-emphasis border border-success-subtle';
      case 'FAILED':
        return 'bg-danger-subtle text-danger-emphasis border border-danger-subtle';
      case 'CANCELLED':
        return 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle';
      default:
        return 'bg-warning-subtle text-warning-emphasis border border-warning-subtle';
    }
  }

  private loadPaymentStatus(): void {
    this.settingsService.getClinicSubscriptionPaymentStatus().subscribe({
      next: (status) => (this.paymentStatus = status),
      error: () => (this.paymentStatus = null),
    });
  }

  payWithYoco(): void {
    this.isStartingPayment = true;
    this.settingsService.createClinicYocoCheckout().subscribe({
      next: (checkout) => {
        // Redirect the browser to the Yoco hosted checkout page
        window.location.href = checkout.redirectUrl;
      },
      error: (error) => {
        this.isStartingPayment = false;
        this.notificationService.error(
          error?.error?.message || 'Unable to start the Yoco payment.',
        );
      },
    });
  }
}
